import { useCallback, useMemo, useState } from 'react';
import type { AccountFormTagFields } from '../accountFormTags';

export interface AccountDetailsFormValues extends AccountFormTagFields {
  Name: string;
  AccountNumber: string;
  AccountBalance: string;
  Notes: string;
  AccountSubType: string | undefined; // must be a string for mui.
  MonthlyPaymentAmount: string;
  InitialLoanAmount: string;
  InterestRate: string;
  ClassificationId: number | undefined;
  ParentId: number | undefined;
}

export interface AccountDetailsFormState {
  values: AccountDetailsFormValues;
  isValid: boolean;
}

const INITIAL_VALUES: AccountDetailsFormValues = {
  Name: '',
  AccountNumber: '',
  AccountBalance: '',
  Notes: '',
  AccountSubType: '',
  MonthlyPaymentAmount: '',
  InitialLoanAmount: '',
  InterestRate: '',
  ClassificationId: undefined,
  ParentId: undefined,
  SelectedTagIds: [],
};

const INITIAL_STATE: AccountDetailsFormState = {
  values: INITIAL_VALUES,
  isValid: false,
};

const useAccountDetailsForm = () => {
  const [accountDetailsForm, setAccountDetailsForm] =
    useState<AccountDetailsFormState>(INITIAL_STATE);

  const updateAccountDetailForm = useCallback(
    (state: AccountDetailsFormState) => {
      setAccountDetailsForm((prev) => {
        if (prev.isValid === state.isValid && prev.values === state.values) {
          return prev;
        }
        return state;
      });
    },
    [],
  );

  const resetAccountDetailForm = useCallback(() => {
    setAccountDetailsForm(INITIAL_STATE);
  }, []);

  return useMemo(
    () => ({
      resetAccountDetailForm,
      accountDetailsForm,
      updateAccountDetailForm,
    }),
    [accountDetailsForm, resetAccountDetailForm, updateAccountDetailForm],
  );
};

export default useAccountDetailsForm;
